import { render, staticRenderFns } from "./competitionManagement.vue?vue&type=template&id=05fe2dbe&scoped=true"
import script from "./competitionManagement.vue?vue&type=script&lang=js"
export * from "./competitionManagement.vue?vue&type=script&lang=js"
import style0 from "./competitionManagement.vue?vue&type=style&index=0&id=05fe2dbe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05fe2dbe",
  null
  
)

export default component.exports